function walkGameEventTimer(conf,walker){
    PIXI.Container.call(this);
    conf=$.extend(true,{
        pos:[750,640],
        pos_text:[50,25],
        pos_belt:[4,55],
        pos_img:[140,50],
        event_arr:["slow","stop"],
    },conf);
    this.delta_sum=0;
    this.conf=conf;
    this.x=conf.pos[0];
    this.y=conf.pos[1];
    
    this.textObj=new myPixiObj.showText("20.00",{
        font_color:"#ff34b5",
        font_size:35,
        font_family: "VT323"
    });
    this.textObj.x=conf.pos_text[0];
    this.textObj.y=conf.pos_text[1];
    this.addChild(this.textObj);
    this.objSet={};
    var i,name;
    for(i in conf.event_arr){
        name=conf.event_arr[i];
        this.objSet[name]=new myPixiElement.img({img:"img_event_ui_"+name,anchor:[0.5,1]});
        this.objSet[name].x=conf.pos_img[0];
        this.objSet[name].y=conf.pos_img[1];
        this.addChild(this.objSet[name]);
        this.objSet[name].alpha=0;
    }
    
    
    var texture = new PIXI.Texture(PIXI.utils.TextureCache["img_ui_fill"]);
    
    this.belt=new PIXI.Sprite(texture);
    
    this.belt_size=[this.belt.width,this.belt.height];
    this.belt.x=conf.pos_belt[0];
    this.belt.y=conf.pos_belt[1];
    
    this.addChild(this.belt);
    
    this.belt.alpha=0;
    this.textObj.alpha=0;
    
    this.step=0;
    this.step_max=0;
    this.type_cur="";
    this.howlong_mili=0;
    
    this.walker=walker;
    
}
walkGameEventTimer.prototype = Object.create(PIXI.Container.prototype);
walkGameEventTimer.prototype=$.extend(walkGameEventTimer.prototype,{
    start:function(type,howlong_mili){
        if(this.type_cur!=""){
            this.objSet[this.type_cur].alpha=0;
        }
        this.type_cur=type;
        
        this.objSet[this.type_cur].alpha=1;
        this.belt.alpha=1;
        this.textObj.alpha=1;
        
        this.howlong_mili=howlong_mili;
        this.step=0;
        this.step_max=howlong_mili*60/1000;
        
        
        this.walker.startBar();
        
        _moduleEvents.trigger("walksound","start_event");
    },
    stop:function(){
        this.objSet[this.type_cur].alpha=0;
        this.step_max=0;
        
        this.belt.alpha=0;
        this.textObj.alpha=0;
        
        this.walker.stopBar();
    },
    myUpdate:function(delta){
        if(this.step_max>0){
            this.step+=delta;
            this.step=Math.min(this.step,this.step_max);
            
            var howlong=Math.round(this.howlong_mili*(1-this.step/this.step_max));
            
            var howlong_dis=Number.parseFloat(howlong/1000).toFixed(2);
            
            this.textObj.changeText(howlong_dis);
            
            this.belt.texture.frame=new PIXI.Rectangle(0,0,this.belt_size[0]*this.step/this.step_max,this.belt_size[1]);
            
            this.walker.updateBar(this.step/this.step_max);
            
            if(this.step==this.step_max){
                this.stop();
            }
        }
        
    } 
});